<nav class="navbar navbar-expand-lg fixed-top">
    <img src="/assets/img/logotipo.png" width="15%">&nbsp;&nbsp;
    <!--<a class="navbar-brand" [routerLink]="['home']" [routerLinkActive]="['router-link-active']" >SIC</a>-->
    <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item dropdown" ngbDropdown>
                <a href="javascript:void(0)" class="nav-link" ngbDropdownToggle>
                    <i  class="fa fa-user"></i> <mat-icon>perm_identity</mat-icon> {{username}} <b class="caret"></b>
                </a>
                <a class="dropdown-item" (click)="logout()" ><!--[routerLink]="['/login']"-->
                    <i class="fa fa-fw fa-power-off" ></i> {{ 'Cerrar Sesión' }} <mat-icon>logout</mat-icon>
                </a>

            </li>
        </ul>
    </div>
</nav>
